import './ForgotPasswordApp.less';
import React, {useState, useEffect} from 'react';
import BeforeLoginTemplate from "../../templates/before-login/BeforeLoginTemplate";
import __ from "../../i18n";
import routes from "../../routing/routes";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../bootstrap/api/Request";
import AuthSendPasswordResetEmailParcel from "../../api/endpoints/auth/AuthSendPasswordResetEmailParcel";
import Icon from "../../../bootstrap/components/icon/Icon";
import {Link} from "react-router-dom";


export default function ForgotPasswordApp() {

    const [emailSent, setEmailSent] = useState(false);

    const getFieldsConfig = () => {
        return {
            email: {
                type: 'text',
                name: __('Your email'),
                rules: {
                    required: true,
                    match: 'email'
                },
                options: {
                    appearance: 'box',
                    placeholder: __('email@example.com')
                }
            }
        };
    };

    const getLayoutConfig = () => {
        return [
            'email',
            <div key="recover-guidelines" className="recover-guidelines">
                {__('We will send you an email with instructions on how to recover your password.')}
            </div>
        ];
    };

    const handleSubmit = (values, onSuccess, onError) => {
        Request.add(new AuthSendPasswordResetEmailParcel(values.email))
            .then(data => {
                setEmailSent(true);
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    if (emailSent) {
        return <div className="forgot-password-app">
            <BeforeLoginTemplate>
                <div className="success-block">
                    <Icon name="tick-circle"/>
                </div>
                <div className="success-title">{__('Password recovery link sent')}</div>
                <div className="success-message">{__('password_recovery_link_sent_message')}</div>
                <div className="divider"/>
                <div className="success-login-ask">
                    <Link className="text-link" to={routes.login.getUrl()}>{__('Back to login')}</Link>
                </div>
            </BeforeLoginTemplate>
        </div>;
    }

    return <div className="forgot-password-app">
        <BeforeLoginTemplate>
            <div className="app-title">{__('Recover your password')}</div>
            <div className="login-ask">
                <span>{__('Remember your password?')}</span>
                <Link className="text-link" to={routes.login.getUrl()}>{__('Login')}</Link>
            </div>
            <CustomForm
                fieldsConfig={getFieldsConfig()}
                layoutConfig={getLayoutConfig()}
                submit={handleSubmit}
                submitText={__('Send recovery link')}
                allowsSubmit={(hasChanges, values, errors) => Object.keys(errors).length === 0}
            />
        </BeforeLoginTemplate>
    </div>;
}
